import { Injectable } from "@angular/core";
import { HttpClient } from "@angular/common/http";
import { Observable } from "rxjs";
import { environment } from "../../../environments/environment";

/**
 * 🔹 Payload para crear/actualizar
 */
export interface ConsecuenciaPayload {
  descripcion: string;
  estado?: number;
}

/**
 * 🔹 Entidad
 */
export interface Consecuencia {
  id?: number;
  descripcion: string;
  estado: number;
  fechaCreacion?: string;
  fechaModificacion?: string | null;
}

/**
 * 🔹 Respuesta genérica
 */
export interface ConsecuenciaResponse {
  id?: number;
  message?: string;
  error?: string;
  data?: any;
  [key: string]: any;
}

@Injectable({
  providedIn: "root",
})
export class ConsecuenciaService {
  private readonly apiUrl = `${environment.apiUrl}/api/consecuencia`;

  constructor(private http: HttpClient) {}

  // Obtener todas las consecuencias
  getAll(): Observable<Consecuencia[]> {
    return this.http.get<Consecuencia[]>(this.apiUrl, {
      withCredentials: true,
    });
  }

  // Obtener consecuencia por ID
  getById(id: number): Observable<Consecuencia> {
    return this.http.get<Consecuencia>(
      `${this.apiUrl}/${id}`,
      {
        withCredentials: true,
      }
    );
  }

  // Crear consecuencia
  create(
    payload: ConsecuenciaPayload
  ): Observable<ConsecuenciaResponse> {
    return this.http.post<ConsecuenciaResponse>(
      this.apiUrl,
      payload,
      {
        withCredentials: true,
      }
    );
  }

  // Actualizar consecuencia
  update(
    id: number,
    payload: Partial<ConsecuenciaPayload>
  ): Observable<ConsecuenciaResponse> {
    return this.http.put<ConsecuenciaResponse>(
      `${this.apiUrl}/${id}`,
      payload,
      {
        withCredentials: true,
      }
    );
  }

  // Eliminar consecuencia
  remove(id: number): Observable<any> {
    return this.http.delete<any>(
      `${this.apiUrl}/${id}`,
      {
        withCredentials: true,
      }
    );
  }

  // Inactivar consecuencia
  inactivar(id: number): Observable<ConsecuenciaResponse> {
    return this.http.put<ConsecuenciaResponse>(
      `${this.apiUrl}/${id}/inactivar`,
      {},
      {
        withCredentials: true,
      }
    );
  }

  // Activar consecuencia
  activar(id: number): Observable<ConsecuenciaResponse> {
    return this.http.put<ConsecuenciaResponse>(
      `${this.apiUrl}/${id}/activar`,
      {},
      {
        withCredentials: true,
      }
    );
  }
}